module.exports = __webpack_public_path__ + "img/MTA200109.501285b2.png";